import { render, staticRenderFns } from "./Login2FA.vue?vue&type=template&id=2a8bcdd7&scoped=true"
import script from "../services/Login2FA.js?vue&type=script&lang=js&external"
export * from "../services/Login2FA.js?vue&type=script&lang=js&external"
import style0 from "./Login2FA.vue?vue&type=style&index=0&id=2a8bcdd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bcdd7",
  null
  
)

export default component.exports